import { useState, useEffect } from "react";
import { calculateCountdown } from "../utils/weekUtils";

interface CountdownData {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
}

/**
 * Custom hook to manage countdown timer
 * Updates every second
 */
export const useCountdown = () => {
  const [countdown, setCountdown] = useState<CountdownData>(
    calculateCountdown()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(calculateCountdown());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return countdown;
};

/**
 * Format countdown for display
 */
export const formatCountdown = (countdown: CountdownData): string => {
  if (countdown.isExpired) {
    return "Week Ended";
  }

  const { days, hours, minutes, seconds } = countdown;
  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};
